// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"941":"cd00bea0","3412":"2995c9cf","4230":"2995c9cf","5041":"4933da0a","9240":"8fafdab5"}[chunkId] + ".chunk.css";
};